export enum UserRole {
  member = 'member',
  customer = 'customer',
  user = 'user',
  subadmin = 'subadmin',
  admin = 'admin',
  superadmin = 'super-admin',
}
